export const LAUNDRY_SERVICE_MODEL = {
  IN_HOUSE_ONLY: "IN_HOUSE_ONLY",
  OUTSOURCED_ONLY: "OUTSOURCED_ONLY",
  HYBRID: "HYBRID",
};

export const SERVICE_MODEL_OPTIONS = [
  { value: LAUNDRY_SERVICE_MODEL.IN_HOUSE_ONLY, label: "In-House Only" },
  { value: LAUNDRY_SERVICE_MODEL.OUTSOURCED_ONLY, label: "Outsourced Only" },
  { value: LAUNDRY_SERVICE_MODEL.HYBRID, label: "Hybrid" },
];

export const LAUNDRY_POSTING_TRIGGER = {
  ON_ORDER_CONFIRMATION: "ON_ORDER_CONFIRMATION",
  ON_DELIVERY: "ON_DELIVERY",
};

export const POSTING_TRIGGER_OPTIONS = [
  { value: LAUNDRY_POSTING_TRIGGER.ON_ORDER_CONFIRMATION, label: "On Order Confirmation" },
  { value: LAUNDRY_POSTING_TRIGGER.ON_DELIVERY, label: "On Delivery" },
];

export const SERVICE_PROVIDER = { IN_HOUSE: "IN_HOUSE", VENDOR: "VENDOR" };

export const SERVICE_TYPE = {
  NORMAL: "NORMAL",
  EXPRESS: "EXPRESS",
  SUPER_EXPRESS: "SUPER_EXPRESS",
};

export const SERVICE_TYPE_OPTIONS = [
  { value: SERVICE_TYPE.NORMAL, label: "Normal" },
  { value: SERVICE_TYPE.EXPRESS, label: "Express" },
  { value: SERVICE_TYPE.SUPER_EXPRESS, label: "Super Express" },
];

export const UNIT_OPTIONS = [
  { value: "PIECE", label: "Piece" },
  { value: "PAIR", label: "Pair" },
  { value: "SET", label: "Set" },
  { value: "KG", label: "Kg" },
];

export const GENDER_OPTIONS = [
  { value: "UNISEX", label: "Unisex" },
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
];

export const TICKET_TYPE = { GUEST: "GUEST", NON_REVENUE: "NON_REVENUE" };

export const LAUNDRY_STATUS = {
  REQUESTED: "REQUESTED",
  PICKED_UP: "PICKED_UP",
  IN_PROCESS: "IN_PROCESS",
  QUALITY_CHECK: "QUALITY_CHECK",
  READY: "READY",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  REPROCESS: "REPROCESS",
  MISSING: "MISSING",
  CANCELLED: "CANCELLED",
  PARTIALLY_DELIVERED: "PARTIALLY_DELIVERED",
};

export const STATUS_LABELS = {
  REQUESTED: "Requested",
  PICKED_UP: "Picked Up",
  IN_PROCESS: "In Process",
  QUALITY_CHECK: "Quality Check",
  READY: "Ready",
  OUT_FOR_DELIVERY: "Out for Delivery",
  DELIVERED: "Delivered",
  REPROCESS: "Reprocess",
  MISSING: "Missing",
  CANCELLED: "Cancelled",
  PARTIALLY_DELIVERED: "Partially Delivered",
};

export const STATUS_STYLES = {
  REQUESTED: { color: "#8A6100", bg: "#FFF6E0", border: "#F1D48A" },
  PICKED_UP: { color: "#1F4E79", bg: "#E8EFF7", border: "#B8CDE4" },
  IN_PROCESS: { color: "#1F4E79", bg: "#E8EFF7", border: "#B8CDE4" },
  QUALITY_CHECK: { color: "#6A3FA0", bg: "#F2EBFA", border: "#D6C2EE" },
  READY: { color: "#1B7F3B", bg: "#E8F6EC", border: "#B7E2C4" },
  OUT_FOR_DELIVERY: { color: "#1B7F3B", bg: "#E8F6EC", border: "#B7E2C4" },
  DELIVERED: { color: "#1B7F3B", bg: "#E8F6EC", border: "#B7E2C4" },
  REPROCESS: { color: "#8A6100", bg: "#FFF6E0", border: "#F1D48A" },
  MISSING: { color: "#B3261E", bg: "#FDECEA", border: "#F5C2BE" },
  CANCELLED: { color: "#6B6B6B", bg: "#F2F2F2", border: "#DCDCDC" },
  PARTIALLY_DELIVERED: { color: "#8A6100", bg: "#FFF6E0", border: "#F1D48A" },
};

export const ORDER_TABS = [
  { key: "ALL", label: "All" },
  { key: "ACTIVE", label: "Active" },
  { key: "REQUESTED", label: "Requested" },
  { key: "PICKED_UP", label: "Picked Up" },
  { key: "IN_PROCESS", label: "In Process" },
  { key: "QUALITY_CHECK", label: "Quality Check" },
  { key: "READY", label: "Ready" },
  { key: "OUT_FOR_DELIVERY", label: "Out for Delivery" },
  { key: "MISSING", label: "Missing" },
  { key: "REPROCESS", label: "Reprocess" },
  { key: "DELIVERED", label: "Delivered" },
  { key: "CANCELLED", label: "Cancelled" },
];

export const DISPATCH_TABS = [
  { key: "ALL", label: "All" },
  { key: "WITH_VENDOR", label: "With Vendor" },
  { key: "PARTIALLY_RETURNED", label: "Partially Returned" },
  { key: "RECONCILED", label: "Reconciled" },
  { key: "WRITTEN_OFF", label: "Written Off" },
  { key: "OVERDUE", label: "Overdue" },
];

export const DISPATCH_STATUS_LABELS = {
  WITH_VENDOR: "With Vendor",
  PARTIALLY_RETURNED: "Partially Returned",
  RECONCILED: "Reconciled",
  WRITTEN_OFF: "Written Off",
};

export const DISPATCH_CLOSED_STATUSES = ["RECONCILED", "WRITTEN_OFF"];

export const isDispatchClosed = (status) =>
  DISPATCH_CLOSED_STATUSES.includes(status);

export const COMPLAINT_TABS = [
  { key: "", label: "All" },
  { key: "OPEN", label: "Open" },
  { key: "PENDING_APPROVAL", label: "Pending Approval" },
  { key: "CLOSED", label: "Closed" },
  { key: "REJECTED", label: "Rejected" },
];

export const COMPLAINT_TYPE_OPTIONS = [
  { value: "DAMAGE", label: "Damage" },
  { value: "LOSS", label: "Loss" },
  { value: "QUALITY", label: "Quality Complaint" },
];

export const COMPLAINT_RESOLUTION_OPTIONS = [
  { value: "NO_COMPENSATION", label: "Close without compensation" },
  { value: "WAIVER", label: "Waive the charge" },
  { value: "FOLIO_CREDIT", label: "Credit the folio" },
  { value: "COST_RECOVERY", label: "Department cost recovery" },
];

export const RECOVERY_STATUS_OPTIONS = [
  { value: "PENDING", label: "Pending" },
  { value: "WRITTEN_OFF", label: "Written Off" },
  { value: "RECOVERED_FROM_EMPLOYEE", label: "Recovered From Employee" },
  { value: "NO_RECOVERY", label: "No Recovery" },
];

export const BILLING_PREFERENCE = {
  BILL_TO_ROOM: "BILL_TO_ROOM",
  PAY_SEPARATELY: "PAY_SEPARATELY",
};

export const BILLING_PREFERENCE_OPTIONS = [
  { value: BILLING_PREFERENCE.BILL_TO_ROOM, label: "Bill to Room" },
  { value: BILLING_PREFERENCE.PAY_SEPARATELY, label: "Pay Separately" },
];

export const billingActionVisibility = (ticket) => {
  const isPaySeparately =
    ticket?.billing_preference === BILLING_PREFERENCE.PAY_SEPARATELY;
  const isSettled = Number(ticket?.billing?.settled_total || 0) > 0;
  const isRefunded = Number(ticket?.billing?.refunded_total || 0) > 0 && !isSettled;
  const postedTotal = Number(ticket?.billing?.posted_total || 0);
  const billableLines = (ticket?.laundry_items || []).filter(
    (line) => line.line_status !== "CANCELLED"
  ).length;
  const postedLines = (ticket?.billing?.posted_line_ids || []).length;
  const hasUnpostedLines = billableLines === 0 || postedLines < billableLines;

  return {
    canPost: !isPaySeparately && !isRefunded && hasUnpostedLines,
    canReverse: !isPaySeparately && postedTotal > 0,
    canSettleSeparately: !isSettled && !isRefunded,
    canToggleInvoiceExclusion: !isPaySeparately && !isRefunded,
    canDiscount: !isRefunded && !(isPaySeparately && isSettled),
    canCredit: !isPaySeparately && postedTotal > 0,
    canRefund: isPaySeparately && isSettled,
  };
};

export const BILLING_STATUS_LABELS = {
  NOT_REQUIRED: "Not Required",
  PENDING: "Pending",
  POSTED: "Posted",
  PARTIALLY_POSTED: "Partially Posted",
  PAID_SEPARATELY: "Paid Separately",
  REVERSED: "Reversed",
  REFUND_PENDING: "Refund Pending",
  REFUNDED: "Refunded",
  FAILED: "Failed",
};

export const STATUS_TRANSITIONS = {
  REQUESTED: ["PICKED_UP", "CANCELLED"],
  PICKED_UP: ["IN_PROCESS", "CANCELLED"],
  IN_PROCESS: ["QUALITY_CHECK", "MISSING", "CANCELLED"],
  QUALITY_CHECK: ["READY", "REPROCESS", "MISSING", "CANCELLED"],
  READY: ["OUT_FOR_DELIVERY", "CANCELLED"],
  OUT_FOR_DELIVERY: ["DELIVERED", "MISSING"],
  REPROCESS: ["IN_PROCESS"],
  MISSING: ["READY", "CANCELLED"],
  DELIVERED: [],
  CANCELLED: [],
};

export const REASON_REQUIRED_STATUSES = ["MISSING", "REPROCESS", "CANCELLED"];

export const DAY_OPTIONS = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

export const statusLabel = (status) => STATUS_LABELS[status] || status || "-";

export const allowedNext = (status) => STATUS_TRANSITIONS[status] || [];

export const VENDOR_SETTLED_REQUIRED_STATUSES = ["QUALITY_CHECK", "READY", "DELIVERED"];

export const isSeparatelyInvoiced = (charge) =>
  !!charge?.exclude_from_checkout_invoice ||
  charge?.billing_preference === "PAY_SEPARATELY";

export const splitInvoiceCharges = (charges) => {
  const all = Array.isArray(charges) ? charges : [];
  const printed = all.filter((c) => !isSeparatelyInvoiced(c));
  const separate = all.filter(isSeparatelyInvoiced);
  const sum = (rows) =>
    Math.round(rows.reduce((t, c) => t + Number(c?.total || 0), 0) * 100) / 100;
  return { all, printed, separate, printedTotal: sum(printed), separateTotal: sum(separate) };
};

export const isVendorRoundTripPending = (ticket) =>
  ticket?.service_provider_type === "VENDOR" &&
  Number(ticket?.vendor_unsettled_line_count || 0) > 0;

export const vendorGatedNext = (status, ticket) => {
  const next = allowedNext(status);
  if (!isVendorRoundTripPending(ticket)) return next;
  return next.filter((value) => !VENDOR_SETTLED_REQUIRED_STATUSES.includes(value));
};

export const money = (value) =>
  `₹${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const taxLabel = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  const percent = Number(value);
  if (!Number.isFinite(percent)) return "—";
  return `${Number(percent.toFixed(2))}%`;
};

export const tierPrice = (item, serviceType) => {
  if (!item) return null;
  if (serviceType === SERVICE_TYPE.NORMAL) {
    return { price: item.normal_price, tat: item.normal_tat_hours };
  }
  if (serviceType === SERVICE_TYPE.EXPRESS) {
    return item.express_price === null || item.express_price === undefined
      ? null
      : { price: item.express_price, tat: item.express_tat_hours };
  }
  if (serviceType === SERVICE_TYPE.SUPER_EXPRESS) {
    return item.super_express_price === null || item.super_express_price === undefined
      ? null
      : { price: item.super_express_price, tat: item.super_express_tat_hours };
  }
  return null;
};

export const availableTiers = (item) =>
  SERVICE_TYPE_OPTIONS.filter((option) => !!tierPrice(item, option.value));

export const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const toLocalInputValue = (value) => {
  const date = value ? new Date(value) : new Date();
  if (Number.isNaN(date.getTime())) return "";
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() - offset * 60000).toISOString().slice(0, 16);
};

/**
 * Reasons are free text that may embed a raw enum, e.g.
 * "Posted on ON_ORDER_CONFIRMATION". The API stopped writing those on
 * 2026-09-11, but rows written before that keep the raw token forever, so it
 * is normalised at render time rather than left to age out.
 *
 * The posting triggers are mapped explicitly: ON_ORDER_CONFIRMATION sits after
 * the word "on" in the sentence, so humanising it generically would read
 * "Posted on on order confirmation". These renderings match what the API
 * writes today, so old and new rows read identically.
 */
const REASON_TOKEN_LABELS = {
  ON_ORDER_CONFIRMATION: "Order Confirmation",
  ON_DELIVERY: "Delivery",
};

const REASON_TOKEN_PATTERN = /[A-Z][A-Z0-9]*(?:_[A-Z0-9]+)+/g;

export const humanizeReason = (text) => {
  if (text === null || text === undefined || text === "") return "-";
  return String(text).replace(
    REASON_TOKEN_PATTERN,
    (token) => REASON_TOKEN_LABELS[token] ?? humanizeEnum(token)
  );
};

export const humanizeEnum = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return String(value)
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const COMPLAINT_TYPE_LABELS = {
  DAMAGE: "Damage",
  LOSS: "Loss",
  QUALITY: "Quality",
};

export const COMPLAINT_STATUS_LABELS = {
  OPEN: "Open",
  UNDER_REVIEW: "Under Review",
  CLOSED: "Closed",
  REJECTED: "Rejected",
};

export const RESOLUTION_TYPE_LABELS = {
  NO_COMPENSATION: "No Compensation",
  WAIVER: "Waiver",
  FOLIO_CREDIT: "Folio Credit",
  COST_RECOVERY: "Cost Recovery",
};

export const RECOVERY_STATUS_LABELS = {
  PENDING: "Pending",
  WRITTEN_OFF: "Written Off",
  RECOVERED_FROM_EMPLOYEE: "Recovered From Employee",
  NO_RECOVERY: "No Recovery",
};

export const SERVICE_TYPE_LABELS = {
  NORMAL: "Normal",
  EXPRESS: "Express",
  SUPER_EXPRESS: "Super Express",
};

export const SERVICE_PROVIDER_LABELS = {
  IN_HOUSE: "In-House",
  VENDOR: "Vendor",
};

const labelsFromOptions = (options) =>
  options.reduce((map, option) => ({ ...map, [option.value]: option.label }), {});

export const POSTING_TRIGGER_LABELS = labelsFromOptions(POSTING_TRIGGER_OPTIONS);

export const UNIT_LABELS = labelsFromOptions(UNIT_OPTIONS);

export const GENDER_LABELS = labelsFromOptions(GENDER_OPTIONS);

export const BILLING_PREFERENCE_LABELS = labelsFromOptions(BILLING_PREFERENCE_OPTIONS);

export const SERVICE_MODEL_LABELS = labelsFromOptions(SERVICE_MODEL_OPTIONS);

export const BILLING_METHOD_LABELS = {
  BILL_TO_ROOM: "Bill to Room",
  PAID_SEPARATELY: "Paid Separately",
  SEPARATELY_INVOICED: "Separately Invoiced",
};

export const TRANSACTION_TYPE_LABELS = {
  POST: "Post",
  REVERSAL: "Reversal",
  ADJUSTMENT: "Adjustment",
  CREDIT: "Credit",
  PAYMENT: "Payment",
  REFUND: "Refund",
};

export const AUDIT_MODULE_LABELS = {
  laundry_ticket: "Laundry Request",
  laundry_ticket_item: "Request Line",
  laundry_billing_transaction: "Billing",
  laundry_config: "Settings",
  laundry_item: "Item Master",
  laundry_category: "Category Master",
  laundry_vendor: "Vendor",
  laundry_vendor_rate: "Vendor Rate",
  laundry_vendor_dispatch: "Vendor Dispatch",
  laundry_vendor_dispatch_item: "Dispatch Line",
  laundry_complaint: "Complaint",
  laundry_complaint_photo: "Complaint Photo",
  laundry_cost_recovery: "Cost Recovery",
};

export const AUDIT_ACTION_LABELS = {
  CREATE: "Created",
  UPDATE: "Updated",
  DELETE: "Deleted",
  CANCEL: "Cancelled",
  POST: "Posted",
  REVERSE: "Reversed",
  RESOLVE: "Resolved",
  STATUS_CHANGE: "Status Changed",
  CHECKOUT_ACKNOWLEDGED: "Checkout Acknowledged",
};

export const auditModuleLabel = (entityName) =>
  AUDIT_MODULE_LABELS[entityName] || humanizeEnum(entityName);

export const auditActionLabel = (action) =>
  AUDIT_ACTION_LABELS[action] || humanizeEnum(action);

export const enumText = (value) => humanizeEnum(value);
